import { FileText, Film, Image as ImageIcon, Music } from 'lucide-react';
import { useState } from 'react';

import type { MediaItem, MediaType } from '@/lib/media';
import { cn } from '@/lib/utils';

export const mediaTypeIcons: Record<MediaType, typeof ImageIcon> = {
  image: ImageIcon,
  video: Film,
  audio: Music,
  document: FileText,
};

interface MediaThumbnailProps {
  item: MediaItem;
  className?: string;
}

/** Shared media placeholder: the image for images (falling back to its type icon), otherwise the type icon. */
export function MediaThumbnail({ item, className }: MediaThumbnailProps) {
  const [failed, setFailed] = useState(false);
  const Icon = mediaTypeIcons[item.type];

  return (
    <div className={cn('flex items-center justify-center overflow-hidden bg-muted', className)}>
      {item.type === 'image' && !failed ? (
        <img
          src={item.url}
          alt={item.title || item.filename || ''}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <Icon className="size-6 text-muted-foreground" />
      )}
    </div>
  );
}
